import { render, staticRenderFns } from "./Tx_Info.vue?vue&type=template&id=5b728060&scoped=true"
import script from "./Tx_Info.vue?vue&type=script&lang=js"
export * from "./Tx_Info.vue?vue&type=script&lang=js"
import style0 from "./Tx_Info.vue?vue&type=style&index=0&id=5b728060&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b728060",
  null
  
)

export default component.exports